import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { ProjectId } from 'api/models';
import { useProjectTasksQuery } from 'queries/task';
import { selectTasksByProjectId, getTasksByProjectId } from '../selectors';
/**
 *
 * @deprecated Use `TasksStore.ofProjectId`
 */ export const useTasksFromStore = ([, projectId])=>{
    const tasks = useSelector(selectTasksByProjectId(ProjectId(projectId)), shallowEqual);
    return tasks;
};
export const useTasksFromStoreRQ = (projectId)=>{
    const { data: _tasks } = useProjectTasksQuery(projectId);
    const tasks = useMemo(()=>{
        var _ref;
        return (_ref = _tasks === null || _tasks === void 0 ? void 0 : _tasks.map((e)=>{
            var _e_project, _e_subTasks;
            return {
                ...e,
                project: e === null || e === void 0 ? void 0 : (_e_project = e.project) === null || _e_project === void 0 ? void 0 : _e_project.projectId,
                subTasks: e === null || e === void 0 ? void 0 : (_e_subTasks = e.subTasks) === null || _e_subTasks === void 0 ? void 0 : _e_subTasks.map((x)=>x === null || x === void 0 ? void 0 : x.taskId)
            };
        })) !== null && _ref !== void 0 ? _ref : [];
    }, [
        _tasks
    ]);
    return tasks;
};
export const useTasksByProjectId = (projectId)=>{
    const getTaskObjects = useMemo(getTasksByProjectId, []);
    return useSelector((state)=>getTaskObjects(state, projectId));
};
